import React from 'react';
import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAlicorn } from '@fortawesome/pro-solid-svg-icons';
import ProjectCard from '../../../components/ProjectCard';

const UnicornIcon = styled(FontAwesomeIcon)`
  color: white;
  margin-right: 10px;
`;

const BlogTitle = styled.h3`
  margin-bottom: 5px;
  font-weight: 100;
  color: white;
`;

const EmptyCard = (props) => (
  <ProjectCard {...props}>
    <UnicornIcon size="2x" icon={faAlicorn} />
    <BlogTitle>Watch this space.<br />Cool things coming soon.</BlogTitle>
  </ProjectCard>
);

export default EmptyCard;